import {apiBase} from 'api/base.js';

const MilkingSummaryAPI = {
  create: (params) => {
    return apiBase.request('/admin/milking_summary', 'POST', params);
  }
};

export {MilkingSummaryAPI as milkingSummaryAPI};
